import { createAuthClient } from 'better-auth/react';
import { emailOTPClient } from 'better-auth/client/plugins';

const apiBase = (import.meta.env['VITE_API_BASE'] ?? '/api').replace(/\/$/, '');

/**
 * Better Auth React client. Talks to the Worker's `/auth/*` mount.
 * The client's inferred type references a deep zod subpath that TS can't
 * name portably, so we don't export the client itself — only its hooks
 * and actions, which have stable types of their own.
 */
const authClient = createAuthClient({
  baseURL: `${apiBase}/auth`,
  plugins: [emailOTPClient()],
});

export const useSession = authClient.useSession;
export const signIn = authClient.signIn;
export const signUp = authClient.signUp;
export const signOut = authClient.signOut;
export const emailOtp = authClient.emailOtp;
